import { Box, Flex, Image, Center, useDisclosure } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Connect from "../../assets/connect.svg"
import Logo from "../../assets/logo.svg";
import { useAccount, useDisconnect, useEnsName } from "wagmi";
import { FiX } from "react-icons/fi";
import CommonButton from "../common/CommonButton";
import ConnectorModal from "./ConnectorModal";
import QuestionMenu from "../common/QuestionMenu";

interface propTypes {
  onDrawerClose: any;
}

function NavigationBarDrawer({ onDrawerClose }: propTypes) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { address, connector, isConnected } = useAccount();
  const { data: ensName } = useEnsName({ address });
  const { disconnect } = useDisconnect();

  return (
    <Flex
      direction="column"
      w="full"
      position="relative"
      justify="space-between"
      gap={6}
      minH="98vh"
      fontFamily="'IBM Plex Mono', monospace"
    >
      <QuestionMenu />
      <Flex justify="space-between" alignItems="center">
        <Box>
          <Link to="/">
            <Image
              onClick={onDrawerClose}
              src={Logo}
              w={["1.5rem", "1.5rem", "9%", "9%"]}
              h={["2.5rem", "2.5rem", "7%", "7%"]}
              alt=""
            />
          </Link>
        </Box>
        <Flex
          justify="center"
          gap={2}
          cursor="pointer"
          alignItems="center"
          onClick={onDrawerClose}
        >
          <FiX size={20} />
          <Box fontSize="md" fontWeight="medium">
            Close
          </Box>
        </Flex>
      </Flex>
      <Flex alignItems="center" justify="center">
        {isConnected ? (
          <Flex direction="column" alignItems="center" gap={2}>
            <Box fontWeight="normal" fontSize="lg">
              {ensName
                ? `Address: ${ensName} (${address?.slice(
                    0,
                    8
                  )}.....${address?.slice(address.length - 4, address.length)})`
                : `Address: ${address?.slice(0, 8)}.....${address?.slice(
                    address.length - 4,
                    address.length
                  )}`}
            </Box>
            <Box fontWeight="medium" fontSize="lg" mb="2">
              Connected to {connector?.name}
            </Box>
            <CommonButton
              name="Disconnect"
              onClick={disconnect}
              bg="rgba(187, 247, 208, 1)"
              hoverBg="rgba(74, 222, 128, 1)"
            />
          </Flex>
        ) : (
          <Flex direction="column" alignItems="center" gap={8}>
            <Box
              fontSize={["2xl"]}
              fontWeight="semibold"
              textAlign="center"
              fontFamily="'Poppins', sans-serif"
            >
              Connect your wallet
            </Box>
            <Box
              fontWeight="normal"
              fontSize="sm"
              textAlign="center"
              color="rgba(82, 82, 82, 1)"
            >
              Connect your wallet and start earning stable yield, backed by real
              world assets
            </Box>
            <Box
              fontWeight="semibold"
              maxW="42rem"
              fontSize="sm"
              bg="rgba(224, 242, 254, 1)"
              color="rgba(30, 64, 175, 1)"
              border="1px"
              borderRadius="lg"
              p="4"
            >
              You will be asked to sign a transaction to authenticate you in our
              platform. No funds will be moved and you will not be charged a
              transaction fee.
            </Box>
            <CommonButton
              name="Connect Wallet"
              onClick={onOpen}
              image={Connect}
              bg="rgba(187, 247, 208, 1)"
              hoverBg="rgba(74, 222, 128, 1)"
            />
            <ConnectorModal isModalOpen={isOpen} onModalClose={onClose} />
          </Flex>
        )}
      </Flex>
      <Flex
        w="full"
        alignItems="center"
        justify="center"
        color="rgb(0 0 0 / 85%)"
        overflowX="hidden"
        fontFamily="'IBM Plex Mono', monospace"
      >
        <Center>
          <Flex
            direction="column"
            w="full"
            color="rgb(0 0 0 / 85%)"
            alignItems="start"
            maxW="55rem"
            py={[6]}
            fontSize=".5rem"
            lineHeight="10px"
            fontWeight="normal"
          >
            <Box>APR is subject to change.</Box>
            <Box>
              The information herein is provided to accredited investors and for
              convenience only. Data and values are current as of 1/13/2023, and
              subject to change. Past performance does not guarantee future
              results. All investments carry risk, including the loss of your
              entire investment. Credix does not provide investment advice, and
              is not responsible for the reliability, accuracy, or completeness
              of third-party information. This does not constitute an offer or
              the solicitation of an offer to sell securities, and this material
              should not be relied upon in making any investment decision(s).
            </Box>
          </Flex>
        </Center>
      </Flex>
    </Flex>
  );
}

export default NavigationBarDrawer;
